import { render, staticRenderFns } from "./list-items.vue?vue&type=template&id=24a10b9a&scoped=true"
import script from "./list-items.vue?vue&type=script&lang=js"
export * from "./list-items.vue?vue&type=script&lang=js"
import style0 from "./list-items.vue?vue&type=style&index=0&id=24a10b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a10b9a",
  null
  
)

export default component.exports